import { ThemeToggle } from "../ui/ThemeToggle"
import styles from "./Header.module.css"

export function Header() {
  return (
    <header className={styles.header}>
      <div className={styles.container}>
        <a href="#" className={styles.logo}>
          EK
        </a>
        <ThemeToggle />
      </div>
    </header>
  )
}
